import { useMutation, useQueryClient } from "@tanstack/react-query";
import { ApiError, ApiServiceError } from "libs/api";
import { MutationOptions } from "libs/reactQuery";

import {
  BlockAffinityResult,
  CreateAffinityBlacklistPayload
} from "../../recommendation.types";
import { requestBlockAffinityPairing } from "./blockAffinityPairing.request";

const useBlockAffinityPairing = (
  options?: MutationOptions<
    BlockAffinityResult,
    ApiServiceError<ApiError>,
    CreateAffinityBlacklistPayload
  >
) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: requestBlockAffinityPairing,
    ...options,
    onSuccess: (data, variables, ctx) => {
      // Blocking also deletes the rules it covers, so the rule list is stale too.
      void queryClient.invalidateQueries({
        queryKey: ["recommendation", "affinity"]
      });
      options?.onSuccess?.(data, variables, ctx);
    }
  });
};

export default useBlockAffinityPairing;
